import { conditions } from "helpers";
import { ConditionName } from "interfaces";

const VideoAreaShadow = () => {
    return (
        <div
            className={`pl-w-full pl-h-full pl-absolute pl-top-0 pl-left-0 animate__animated animate__faster ${
                conditions(ConditionName.isActiveElements) ? "animate__fadeIn" : "animate__fadeOut"
            }`}
        >
            <div className="pl-w-full pl-h-full pl-flex pl-flex-col pl-justify-between">
                <div className="pl-w-full pl-h-[100px]" style={{ background: "linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)" }} />
                <div className="pl-w-full pl-h-[100px]" style={{ background: "linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)" }} />
            </div>
        </div>
    );
};

export default VideoAreaShadow;
